/* A chain width page (sections/djh-chain-width.liquid): select a row, filter by choice, sort by length. Prices, weights and the
   date come from the server-rendered rows and the config block; nothing here knows a price or a rule. */
(function () {
  'use strict';
  var root = document.querySelector('[data-djh-chain]');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(root.parentNode.querySelector('[data-djh-chain-config]').textContent); } catch (e) { cfg = {}; }
  var table = root.querySelector('[data-djh-chain-table]');
  var idInput = root.querySelector('[data-djh-chain-id]');
  var priceEl = root.querySelector('[data-djh-chain-price]');
  var basisEl = root.querySelector('[data-djh-chain-basis]');
  var ppgEl = root.querySelector('[data-djh-chain-ppg]');
  if (!table || !idInput) return;

  var money = function (cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: cfg.currency || 'USD', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return '$' + Math.round(cents / 100); }
  };
  var rows = function () { return Array.prototype.slice.call(table.querySelectorAll('[data-djh-chain-row]')); };

  // ready-now rows first within a length, lengths ascending
  rows().sort(function (a, b) {
    var d = (+a.dataset.length) - (+b.dataset.length);
    if (d) return d;
    return (a.dataset.choice === 'ready' ? 0 : 1) - (b.dataset.choice === 'ready' ? 0 : 1);
  }).forEach(function (r) { table.appendChild(r); });

  function select(row) {
    rows().forEach(function (r) { r.classList.toggle('is-selected', r === row); });
    idInput.value = row.dataset.variant;
    var cents = +row.dataset.price, grams = row.dataset.grams, ready = row.dataset.choice === 'ready';
    priceEl.textContent = money(cents);
    var text = cfg.gold || '';
    if (grams) text += (ready ? cfg.basisWeighed : cfg.basisAbout).replace('__G__', grams);
    if (cfg.date) text += (cfg.basisDate || '').replace('__D__', cfg.date);
    basisEl.textContent = text + '.';
    if (ppgEl) {
      if (grams && +grams > 0) { ppgEl.textContent = (cfg.perGram || '').replace('__P__', money(cents / +grams)); ppgEl.hidden = false; }
      else { ppgEl.hidden = true; }
    }
    try {
      var u = new URL(window.location.href); u.searchParams.set('variant', row.dataset.variant);
      window.history.replaceState(null, '', u.toString());
    } catch (e) { /* the page still works without the address bar */ }
  }

  table.addEventListener('change', function (e) {
    var row = e.target.closest('[data-djh-chain-row]');
    if (row && !e.target.disabled) select(row);
  });

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-djh-chain-filter]');
    if (!b) return;
    var f = b.dataset.djhChainFilter;
    root.querySelectorAll('[data-djh-chain-filter]').forEach(function (x) {
      var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    rows().forEach(function (r) { r.hidden = !(f === 'all' || r.dataset.choice === f); });
  });

  var sel = table.querySelector('[data-djh-chain-row].is-selected') || rows()[0];
  if (sel) select(sel);
})();
